






























































































































import {Vue, Component} from 'vue-property-decorator';
import {API} from '@/services/api/api';
import {Utils} from '@/utils/Utils';
import {mapActions, mapGetters} from 'vuex';
import {redirectTime} from '@/constants/constants';
import validationMsgs from '@/constants/validation';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['roleList'])},
})
export default class EditUser extends Vue {
  name = '';
  email = '';
  isLoginEnabled = false;
  enabled = false;
  groupId = -1;
  userId: any = null;
  loadingBtnStatus = false;
  isScreenLoading = true;
  nameValidationMsg: any = null;
  emailValidationMsg: any = null;
  roleValidationMsg: any = null;
  onNullErrorMsg = 'This field is required.';

  showSuccessToast: any;
  showErrorToast: any;

  mounted() {
    this.userId = Number.parseInt(this.$route.params.id);
    this.getUser();
  }

  get isShipMode() {
    return process.env?.VUE_APP_MODE == 'Ship' ? true : false;
  }

  async getUser() {
    try {
      let apiResponse = await API.getUserById(this.userId);
      if (apiResponse.data) {
        const data = apiResponse.data;
        this.name = data.name;
        this.email = data.email;
        const internal = data.internal && data.internal.length ? data.internal[0] : null;
        if (internal) {
          this.groupId = internal.groupId;
          this.isLoginEnabled = internal.user.isLoginEnabled;
          this.enabled = internal.user.enabled;
        }
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  validateName() {
    if (this.name.length < 1 || this.name === '') {
      this.nameValidationMsg = this.onNullErrorMsg;
      return false;
    } else if (!Utils.validateName(this.name)) {
      this.nameValidationMsg = 'Minimum 6 character required only alphabets.';
      return false;
    } else this.nameValidationMsg = null;
    return true;
  }

  validateRole() {
    if (this.groupId === -1) {
      this.roleValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.roleValidationMsg = null;
      return true;
    }
  }

  validateEmail() {
    if (this.email === '' || this.email === null) {
      this.emailValidationMsg = this.onNullErrorMsg;
      return false;
    } else if (!Utils.validateEmail(this.email)) {
      this.emailValidationMsg = 'E-mail is not valid.';
      return false;
    } else {
      this.emailValidationMsg = null;
      return true;
    }
  }

  validateAll() {
    return this.validateName() && this.validateRole() && this.validateEmail();
  }

  //helper methods
  onEnabledChange() {
    if (!this.enabled) {
      this.isLoginEnabled = false;
    }
  }

  onLoginEnabledChange() {
    if (this.isLoginEnabled) {
      this.enabled = true;
    }
  }

  async _updateHandler() {
    if (!this.validateAll()) {
      return false;
    } else {
      this.loadingBtnStatus = true;
      try {
        let response = await API.updateUserById(
          this.userId,
          this.name,
          this.email,
          this.isLoginEnabled,
          this.enabled,
          this.groupId
        );
        this.loadingBtnStatus = false;
        if (response.data) {
          let confirmatonMsg: string = response.message;
          if (confirmatonMsg.includes('User has been updated')) {
            confirmatonMsg = 'Record updated successfully.';
            this.showSuccessToast({msg: confirmatonMsg});
          }

          setTimeout(() => this.$router.go(-1), redirectTime);
        } else {
          let errorMsg = response.error;
          if (errorMsg.includes('already a user with this email')) {
            errorMsg = 'Email already exists.';
          }
          this.showErrorToast({msg: errorMsg});
        }
      } catch (error) {
        this.loadingBtnStatus = false;
        this.showErrorToast({msg: 'Network error'});
      }
    }
  }
}
